import { render } from "./Social.vue?vue&type=template&id=f612dbd8&scoped=true"
import script from "./Social.vue?vue&type=script&lang=js"
export * from "./Social.vue?vue&type=script&lang=js"

import "./Social.vue?vue&type=style&index=0&id=f612dbd8&lang=css&scoped=true"

import exportComponent from "/Users/soup/Development/Vue/futurefest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f612dbd8"]])

export default __exports__